'use client';

import React, { Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import { ChatSidebar } from '@/components/chat/ChatSidebar';
import { ChatWindow } from '@/components/chat/ChatWindow';
import { ChatContextRail, useMatchSeconds } from '@/components/chat/ChatContextRail';
import { ToastContainer } from '@/components/ui/Toast';
import { useChatStore } from '@/store/chatStore';

function ChatContent() {
  const searchParams = useSearchParams();
  const filter = searchParams.get('filter');
  const genderFilter = filter === 'female' ? 'FEMALE' : null;

  const status = useChatStore((s) => s.status);
  const isConnected = status === 'connected';
  const matchSeconds = useMatchSeconds();

  return (
    <div className="bsheet-chat flex bg-brand-black overflow-hidden" style={{ height: '100dvh' }}>
      <div className="hidden md:contents">
        <ChatSidebar />
      </div>
      <ChatWindow initialGenderFilter={genderFilter} matchSeconds={matchSeconds} />
      <div className="hidden xl:contents">
        <ChatContextRail matchSeconds={matchSeconds} isConnected={isConnected} />
      </div>
    </div>
  );
}

export default function ChatPage() {
  return (
    <>
      <Suspense
        fallback={
          <div className="flex h-screen items-center justify-center bg-brand-black">
            <div className="flex flex-col items-center gap-4">
              <div className="w-10 h-10 rounded-full border-2 border-brand-lime border-t-transparent animate-spin" />
              <p className="text-sm text-brand-gray">Loading chat...</p>
            </div>
          </div>
        }
      >
        <ChatContent />
      </Suspense>
      <ToastContainer />
    </>
  );
}
